import React from 'react';
import Modal from "./Modal";
import ModalFooter from "./ModalFooter";
import ThemableSvgIcon from "./theme/ThemableSvgIcon";
import { useLingui } from '@lingui/react/macro';
import { navigate } from '../utils/navigationUtils';

function SuccessModal(props) {
    const {t} = useLingui();
    return (
        <Modal show={props.show}
            onClose={props.onClose}
            title={props.title}>
            <div className="flex grow flex-col">
                <div className="flex grow flex-col justify-center">
                    <div className="text-center mt-8 mb-3">
                        <ThemableSvgIcon
                            className="align-middle w-12 h-12 inline-block text-success"
                            alt="success tick"
                            name="success-tick"
                        />
                    </div>
                    <div className="text-primary-dark text-2xl text-center">
                        <p>
                            {props.message}
                        </p>
                    </div>
                </div>
                <ModalFooter
                    actionDisabled={false}
                    actionButtonText={t({id: "go_to_planner"})}
                    onActionClick={() => {navigate(t({id: "/itinerary"}));}}
                />
            </div>
        </Modal>
    );
}

export default SuccessModal;